import MicroServicesPage from '../aws/MicroServicesPage';

export default function RegionManagementPage() {
  return MicroServicesPage('aws-customer-portal-region-management');
}
